import React from "react";
import Home from "./Home";
import Services from "./Services";
import About from "./About";
import Team from "./Team";
import Portfolio from "./Portfolio";
import Careers from "./Careers";
import Contact from "./Contact";

const HomePage = () => {
  return (
    <>
      <Home />
      <Services />
      <About />
      <Team />
      <Portfolio />
      <Careers />
      <Contact />
    </>
  );
};

export default HomePage;
